import React, {useEffect, useState} from 'react';
import {IonBackButton, IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonItem, IonList, IonModal, IonPage, IonTitle, IonToolbar, isPlatform} from '@ionic/react';
import {close} from 'ionicons/icons';
import {TransformWrapper, TransformComponent} from 'react-zoom-pan-pinch';
import documentIcon from "../imgs/document.png"
import {ApiService} from "../api/ApiService";
import {DocumentInfo} from "../api/model/DocumentsList";
import {VideoInfo} from "../api/model/VideosList";



const Permits: React.FC = () => {


    const[showModalDoc, setShowModalDoc] = useState(false);
    const[showModalVideo, setShowModalVideo] = useState(false);
    const[doc, setDoc] = useState<DocumentInfo>();
    const[docs, setDocList] = useState<DocumentInfo[]>([]);
    const [selectedDocPages, setSelectedDocPages] = useState<any>([]);
    const[vidLink, setVidLink] = useState("");
    const[vidIds, setVidIds] = useState<VideoInfo[]>();

    useEffect(() => {
        console.log("Permits")
        ApiService.getDocsList('permit', {isLp: 0, type: 'permit'}).then(it => {setDocList(it); console.log("new", it)});
        ApiService.sendEventCommand("Checked Permits", "eventCheck", "User checked the permits page");
    }, []);

    function prepDoc(doc: any) {
        let tempArray: number[] = Array.from(Array(doc.numPages).keys())
        setSelectedDocPages(tempArray);
        console.log("Prepped doc", tempArray);
        setShowModalDoc(true);
    }

    return (
        <IonPage >
          <IonHeader >
            <IonToolbar color="primary">
            <IonButtons slot="start">
                <IonBackButton defaultHref="/Home"  text=""/>
              </IonButtons>
              <IonTitle>Permits</IonTitle>
            </IonToolbar>
          </IonHeader>
    
          <IonContent  fullscreen>
            <IonModal isOpen={showModalDoc} cssClass='my-custom-class'>
    
            <IonHeader >
              <IonToolbar color="primary">
                <IonButtons slot="start">
                  <IonButton onClick={ function() { setShowModalDoc(false); }} style={{ minWidth: '72px', minHeight: '48px' }}>
                    <IonIcon slot="icon-only" icon={close} style={{ fontSize: '28px' }} />
                  </IonButton>
                </IonButtons>
              </IonToolbar>
            </IonHeader>  
            <IonContent>
            <TransformWrapper initialScale={1} minScale={1} maxScale={4} centerOnInit key={selectedDocPages.length}>
              <TransformComponent
                wrapperStyle={{ width: '100%', height: '100vh' }}
                contentStyle={{ width: '100%', height: '100%' }}
              >
                <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                  {selectedDocPages.map(function(pages: number) {
                    return (
                      <img
                        key={pages}
                        src={'https://westernexpressmobile.com/docs2/' + doc?.type + '_' + doc?.id + '_' + pages + '.' + doc?.extension}
                        alt={'Page ' + pages}
                        style={{ width: '100%', height: 'auto', display: 'block' }}
                      />
                    );
                  })}
                </div>
              </TransformComponent>
            </TransformWrapper>
              </IonContent>
            </IonModal>
            <IonModal isOpen={showModalVideo} cssClass='my-custom-class'>
            <IonHeader >
              <IonToolbar color="primary">
                <IonButtons slot="start">
                  <IonButton onClick={ function() { setShowModalVideo(false); setVidLink("")}} style={{ width: '72px', minHeight: '28px' }}>
                    <IonIcon slot="icon-only" icon={close} style={{ fontSize: '24px' }}/>
                  </IonButton >
                </IonButtons>
              </IonToolbar>
            </IonHeader>
            </IonModal>
            <div className='main-30-70'>
              <div>

           <h1 style={{textAlign: 'center', color: 'black'}}>Documents</h1>
           {docs.map(function(doc, idx){
             let id = doc.id
             let title = doc.title
              return <IonItem key={id} onClick={() => {setDoc(doc); prepDoc(doc); }} lines="none">
                  <div className='item-container' style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p>{title}</p>
                    <img src={documentIcon} className="link-icon" alt="doc"/>
                  </div>
                  {/* <IonLabel text-wrap>{title}</IonLabel>
                  <IonIcon slot="end" icon={chevronForward}></IonIcon> */}
                </IonItem>
            })} 
              </div>
            </div>
          </IonContent>
        </IonPage>
      );
    };

export default Permits;